import { SERVICE_CLIENT } from '@/services';
import { HELPERS } from '@/utils';
import * as types from './client.types';

const createAction = (service, loadingType, dataType) => {
  return () => async (dispatch) => {
    dispatch({ type: loadingType });
    const { payload, error } = await service();
    if (error) HELPERS.showNotificationServiceError(error);
    dispatch({
      type: dataType,
      payload,
      error,
    });
  };
};

export const ACTION_CLIENT = {
  getClientData: createAction(SERVICE_CLIENT.getClientData, types.GET_CLIENT_LOADING, types.GET_CLIENT_DATA),
  getSocialMedia: createAction(
    SERVICE_CLIENT.getSocialMedia,
    types.GET_SOCIAL_MEDIA_LOADING,
    types.GET_SOCIAL_MEDIA_DATA
  ),
  getPrivacyPolicy: createAction(
    SERVICE_CLIENT.getPrivacyPolicy,
    types.GET_PRIVACY_POLICY_LOADING,
    types.GET_PRIVACY_POLICY_DATA
  ),
  getTermsAndCondition: createAction(
    SERVICE_CLIENT.getTermsAndCondition,
    types.GET_TERMS_AND_CONDITION_LOADING,
    types.GET_TERMS_AND_CONDITION_DATA
  ),
};
